import { css, StyleSheet } from 'aphrodite'
import PropTypes from 'prop-types'
import { COLOR_BLACK } from '../../lib/colors'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'

function UISubtitle({ label, size = 'medium', dynamicStyle }) {
  return (
    <h2
      className={css(
        styles.container,
        styles.default,
        size && styles[`size_${size}`],
        dynamicStyle
      )}
      dangerouslySetInnerHTML={{ __html: `${label}` }}
    />
  )
}

const styles = StyleSheet.create({
  default: {
    color: COLOR_BLACK,
    margin: 0,
  },
  size_small: {
    fontSize: 18,
    fontWeight: 700,
  },
  size_medium: {
    fontSize: 18,
    fontWeight: 600,
    [MEDIA_MIN_SM]: {
      fontSize: 20,
    },
  },
  size_large: {
    [MEDIA_MIN_SM]: {
      fontSize: 28,
    },
    fontSize: 20,
    fontWeight: 600,
  },
})

UISubtitle.propTypes = {
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  dynamicStyle: PropTypes.object,
}

export default UISubtitle
